import { PackageVersion } from "@/features/private-room/bookings/layouts/booking-create-page/booking-create-page.types";

export const CalculateCycleConsumption = (
  activeCycle: PackageVersion,
  additionalCredits?: number,
  upsellCredits?: number,
) => {
  const CONSUMPTION_TYPES = {
    PO_ON_DEMAND: 2,
    BOOKAO: 6,
  } as const;

  const poOnDemandConsumption =
    activeCycle.credits?.consumption[CONSUMPTION_TYPES.PO_ON_DEMAND] || 0;
  const bookaoConsumption =
    activeCycle.credits?.consumption[CONSUMPTION_TYPES.BOOKAO] || 0;

  const newCreditAmount =
    (activeCycle.credits?.amount ?? 0) + (upsellCredits ?? 0);
  const newCreditConsumption =
    (poOnDemandConsumption ?? 0) +
    (bookaoConsumption ?? 0) +
    (additionalCredits ?? 0);

  return {
    newCreditAmount,
    newCreditConsumption,
  };
};
